/**
 * Animation Helper Functions
 * Shared utilities for animation components
 */

/**
 * Safely check if a product is complete
 * @param {Array} personalizationSet - Array of products
 * @param {number} productIndex - Index of the product to check
 * @returns {boolean} - True if product is complete, false otherwise
 */
export function isProductComplete(personalizationSet, productIndex) {
  if (!personalizationSet || !Array.isArray(personalizationSet)) {
    return false;
  }
  const product = personalizationSet[productIndex];
  if (!product) {
    return false;
  }
  return product.isComplete === true;
}

/**
 * Create a safe isComplete checker for use in Vue components
 * @param {Object} props - Component props containing personalizationSet
 * @returns {Function} - Function that checks if a product is complete
 */
export function createIsCompleteChecker(props) {
  return (productIndex) => isProductComplete(props.personalizationSet, productIndex);
}
